import { Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components";

export const TextName = styled(Text)`
    color: #424242;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
`;

export const TextTotal = styled(Text)`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #424242;
`;

export const TextDays = styled(Text)`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #242424;
`;

export const TextMonth = styled(Text)`
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #242424;
    text-transform: capitalize;
`;

export const TextLight = styled(Text)`
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #484644;
`;

export const TextBold = styled(Text)`
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #252423;
`;

export const RowRight = styled(Flex)`
    flex: 2;
`;
export const RowLeft = styled(Flex)`
    flex: 1;
`;
export const Row = styled(Flex)`
    padding-bottom: 12px;
    border-bottom: 1px solid #e1dfdd;
`;

export const Title = styled(Text)`
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
`;

export const Container = styled(Flex)`
    width: 600px;
    height: 486px;
    background: #ffffff;
    padding: 43px 32px 56px 32px;
    box-shadow: 0px 16px 18px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
`;

export const ErrorTitle = styled(Text)`
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
`;

export const ErrorDescription = styled(Text)`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
`;
